import { useQuery, useQueryClient } from 'react-query';
import { Http } from '../../services/Http';
import { AvailableMonthlyTimesheet } from '../../types';
import { QUERY_KEYS } from '../constants';

async function fetchMonthlyTimesheetsByTimeRange(
  userIds: string
): Promise<AvailableMonthlyTimesheet[]> {
  const { data } = await Http.axios.get<AvailableMonthlyTimesheet[]>(
    `/monthly-timesheet/time-range?ids=${userIds}`
  );
  return data;
}

export const useMonthlyTimesheetsByTimeRange = (userIds: string) => {
  return useQuery(
    [QUERY_KEYS.MONTHLY_TIMESHEET_TIME_RANGE, userIds],
    () => fetchMonthlyTimesheetsByTimeRange(userIds),
    {
      staleTime: Infinity, 
      enabled: !!userIds,
      refetchInterval: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      refetchIntervalInBackground: false,
    }
  );
};

export const useInvalidateMonthlyTimesheetsByTimeRange = () => {
  const queryClient = useQueryClient();

  return () => {
    queryClient.invalidateQueries({
      queryKey: QUERY_KEYS.MONTHLY_TIMESHEET_TIME_RANGE,
    });
  };
};
